import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  ICONS
} from './../../../themes'
import {
  ThumbnailIndexWrapper
} from './styled'

export class ThumbnailIndex extends React.PureComponent {
  render () {
    const {
      className,
      onClick,
      name,
      linkName,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'thumbnail-index',
      className
    )

    return (
      <ThumbnailIndexWrapper
        className={classes}
        onClick={onClick}
      >
        <div className='thumbnail-index-text is-name'>
          { name }
        </div>
        <div className='thumbnail-index-text is-link'>
          { linkName }
          <img className='thumbnail-index-icon is-arrow' src={ICONS['ic-arrow-goto-page.svg']} alt='Icon' />
          <img className='thumbnail-index-icon is-arrow-hover' src={ICONS['ic-arrow-goto-page-white.svg']} alt='Icon' />
        </div>
      </ThumbnailIndexWrapper>
    )
  }

  static defaultProps = {
    // * If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
